import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Rx';
import { EventManager , JhiLanguageService  } from 'ng-jhipster';

import { Marketday } from './marketday.model';
import { MarketdayService } from './marketday.service';

@Component({
    selector: 'jhi-marketday-detail',
    templateUrl: './marketday-detail.component.html'
})
export class MarketdayDetailComponent implements OnInit, OnDestroy {

    marketday: Marketday;
    private subscription: any;
    private eventSubscriber: Subscription;

    constructor(
        private eventManager: EventManager,
        private jhiLanguageService: JhiLanguageService,
        private marketdayService: MarketdayService,
        private route: ActivatedRoute
    ) {
        this.jhiLanguageService.setLocations(['marketday', 'marketOperation', 'weekday']);
    }

    ngOnInit() {
        this.subscription = this.route.params.subscribe((params) => {
            this.load(params['id']);
        });
        this.registerChangeInMarketdays();
    }

    load(id) {
        this.marketdayService.find(id).subscribe((marketday) => {
            this.marketday = marketday;
        });
    }
    previousState() {
        window.history.back();
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
        this.eventManager.destroy(this.eventSubscriber);
    }

    registerChangeInMarketdays() {
        this.eventSubscriber = this.eventManager.subscribe('marketdayListModification', (response) => this.load(this.marketday.id));
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/marketday/marketday-detail.component.ts